<template>
  <div class="app-change-tariff-success">
    <dyn-slot :slot-data="slotData">
      <slot name="txtSuccess">
        <h1>VielenDank</h1>
        <div>Vielen Dank! Für Ihre Rufnummer wird innerhalb der nächsten 24 Stunden ein Tarifwechsel in den folgende Tarif
          durchgeführt:<br>
          {{ selectedTariffName }}
        </div>
      </slot>
    </dyn-slot>
    <Stepper
      @prev="prev()"
      :showNext="false"
    >
      <template #btnPrev><slot name="btnPrev"></slot></template>
    </Stepper>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import Stepper from '@/components/generic/Stepper.vue'
import { stepName as previousStep } from '@/components/process/generic/Tariff/rossmann/Input.vue'

export const stepName = 'success'

export default {
  name: 'ChangeTariffSuccess',
  methods: {
    ...mapMutations('changeTariff', [
      'changeStep'
    ]),
    prev () {
      this.changeStep(previousStep)
    }
  },
  computed: {
    ...mapGetters('changeTariff', [
      'selectedTariffName'
    ]),
    slotData: function () {
      return {
        tariffName: this.selectedTariffName
      }
    }
  },
  components: {
    Stepper
  }
}
</script>
